import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { loaderComponent } from '../loader/loader.component';

export interface ResultStats {
  startDate: string;
  checkDate: string;
  checkCount: number;
  daysSinceLast: number;
}

@Component({
  selector: 'app-result-shell',
  standalone: true,
  imports: [CommonModule, MatButtonModule, TranslatePipe, loaderComponent],
  templateUrl: './result-shell.component.html',
  styleUrl: './result-shell.component.scss',
})
export class ResultShellComponent {
  @Input() loading = false;
  @Input() error = '';
  @Input() stats: ResultStats | null = null;
  @Output() back = new EventEmitter<void>();
}
